import TransactionHistoryTable from "./transactionHistorytable.container";

export default TransactionHistoryTable;
